module.exports = __webpack_public_path__ + "img/m1_t2_en.829c44e8.svg";